/**
 * util for ensuring that a value is a list, and making typescript happy. This is needed becuse enonic only returns an array if there are more than one element in a list.
 * if value is null or undefined, we return an empty array.
 * */
export function listify<T>(item: T | T[]): T[] {
  if (item === null || item === undefined) return [];
  const itemList = Array.isArray(item)
    ? item
    : [item];
  return itemList;
}

/** returns true if the value is anything but undefined or null. It will also infer a type if possible and make typescript happy */
export const notNullUndefiend = <T>(val: T | null | undefined): val is T => !(val === undefined || val === null);
